import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Card, Button, Row, Col, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import config from "../Services/apiEndPoints";
import actions from "../redux/examination/actions";
import { useSelector, useDispatch } from "react-redux";

export default function EnrollmentedExamsList() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { activeexam, isFetching } = useSelector((state) => state.Examination);
  const [isExamAvailable, setIsExamAvailable] = useState(false);




  const getExamdetails = useCallback(() => {
    const studentId = localStorage.getItem("Student_Id");
    const examId=localStorage.getItem("examId")

    dispatch(
      actions.getexamdetails(`${config.getactiveexam}?studentId=${studentId}&examinationId=${examId}`)
    );
  }, [dispatch]);

  useEffect(() => {
    getExamdetails();
  }, [getExamdetails]);



  useEffect(() => {
    const examStartTime = activeexam[0]?.tests[0]?.exam_start_time;
    const durationMinutes =
      activeexam[0]?.tests[0]?.question_paper_data?.duration_minutes || 0;

    if (examStartTime) {
      const examStartDate = new Date(examStartTime);
      // Calculate the exam end time by adding the duration to the start time
      const examEndDate = new Date(examStartDate?.getTime() + durationMinutes * 60000);

      const interval = setInterval(() => {
        const currentTime = new Date();
        if (currentTime >= examStartDate && currentTime <= examEndDate) {
          setIsExamAvailable(true);
        } else {
          setIsExamAvailable(false);
        }
      }, 1000); // Check every second

      return () => clearInterval(interval); // Cleanup interval on component unmount
    }
  }, [activeexam]);
  const examTime = useMemo(() => {
    const durationMinutes =
      activeexam[0]?.tests[0]?.question_paper_data?.duration_minutes || 0;
    const hours = Math.floor(durationMinutes / 60);
    const minutes = durationMinutes % 60;
    return `${hours}h ${minutes}m`;
  }, [activeexam]);

  const formattedDate = useMemo(() => {
    const examStartTime = activeexam[0]?.tests[0]?.exam_start_time;
    if (examStartTime) {
      return new Date(examStartTime).toLocaleString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "numeric",
        hour12: true,
      });
    }
    return "N/A";
  }, [activeexam]);

  return (
    <div>
      <Row gutter={16} justify="center" style={{ padding: "16px" }}>
        <Col xs={24} sm={24} md={24} lg={24} style={{ marginBottom: 16 }}>
          <Card
            title={activeexam[0]?.exam_name || "Exam Name"}
            bordered={false}
            style={{
              width: "100%",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.3)",
            }}
          >
            <Row gutter={16} align="middle">
              <Col span={16}>
                <Typography.Title level={5}>
                  {activeexam[0]?.tests[0]?.question_paper_data?.subject ||
                    "Subject"}
                </Typography.Title>
                <Typography.Title level={5}>
                  {activeexam[0]?.exam_description || "Exam Description"}
                </Typography.Title>
              </Col>
              <Col span={8} style={{ textAlign: "center" }}>
                <Typography.Paragraph>Date: {formattedDate}</Typography.Paragraph>
                <Typography.Paragraph>Duration: {examTime}</Typography.Paragraph>
                <Button
                  type="primary"
                  onClick={() => {
                    navigate("/dashboard/examinationPage");
                  }}
                  disabled={!isExamAvailable}
                  style={{ width: "80%", marginTop: "10px" }}
                >
                  Start Exam
                </Button>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
